import './components/formidable-forms'

jQuery(document).on('click', (item) => {
    let header = jQuery('nav.navbar');

    if (!header.is(item.target) &&
        header.has(item.target).length === 0) {
        document.querySelector('.navbar-collapse').classList.remove('show');
    }
});